import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { map, from, catchError, of } from 'rxjs';
import { LoginService } from '@services/login.service';

export const authGuard: CanActivateFn = (route, state) => {
  const loginService = inject(LoginService);
  const router = inject(Router);

  return from(loginService.isLoggedInAsync()).pipe(
    map(isLoggedIn => {
      if (isLoggedIn) {
        return true;
      } else {
        // Redirect to sign-in page if not logged in
        router.navigate(['/signin'], {queryParams: route.queryParams});
        return false;
      }
    }),
    catchError(error => {
      console.error('Auth guard error:', error);
      // On error, redirect to landing page and deny access
      router.navigate(['/signin'], {queryParams: route.queryParams});
      return of(false);
    })
  );
};

export const rootGuard: CanActivateFn = (route, state) => {
  const loginService = inject(LoginService);
  const router = inject(Router);

  return from(loginService.isLoggedInAsync()).pipe(
    map(isLoggedIn => {
      if (isLoggedIn) {
        // User is logged in, redirect to dashboard
        router.navigate(['/dashboard']);
        return false;
      } else {
        // User is not logged in, redirect to landing
        router.navigate(['/landing']);
        return false;
      }
    }),
    catchError(error => {
      console.error('Root guard error:', error);
      // On error, redirect to landing page
      router.navigate(['/landing']);
      return of(false);
    })
  );
};